import { type FC } from "react";
import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Link } from "react-router-dom";

export interface FilterTab {
  value: string;
  label: string;
  to: string;
}

interface FilterTabsProps {
  tabs: FilterTab[];
  value: string;
}

export const FilterTabs: FC<FilterTabsProps> = ({ tabs, value }) => (
  <Card sx={{ overflow: "hidden" }} elevation={0}>
    <AppBar elevation={0} position="static" color="default">
      <Tabs
        value={value}
        indicatorColor="primary"
        scrollButtons="auto"
        variant="scrollable"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            to={tab.to}
            component={Link}
            sx={{ textDecoration: "none !important" }}
          />
        ))}
      </Tabs>
    </AppBar>
  </Card>
);
